import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let deleteButtons = document.querySelectorAll('button[data-remove]');

    for (let i = 0; i < deleteButtons.length; ++i) {
        deleteButtons[i].addEventListener('click', (event) => {
            event.preventDefault();
            Swal.fire({
                title: "Anmeldung löschen",
                text: "Möchten Sie sich wirklich von diesem Kurs abmelden?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d61417",
                cancelButtonColor: "#009fe3",
                confirmButtonText: "Vom Kurs abmelden",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.isConfirmed) {
                    event.target.closest('td').querySelector('form').submit();
                }
            });
        })
    }


}
